import { ServiceHelper2 } from "../../Common/_helpers/ServiceHelper2";
import { BUDGETS_API_URLS } from "../_constants/url.constants";

export const LocationsService = {
    getLocationById,
    getLocationsByAdminEmail,
};

async function getLocationById(locationId) {
    return await ServiceHelper2.getRequest(
        BUDGETS_API_URLS.DISTRIBUTOR_LOCATIONS + "/" + encodeURIComponent(locationId),
    );
}

async function getLocationsByAdminEmail(email) {
    return await ServiceHelper2.getRequest(
        BUDGETS_API_URLS.DISTRIBUTOR_LOCATIONS + "/search?admin_email=" + encodeURIComponent(email),
    );
}
